// Vendor libraries
import { BrowserModule } from '@angular/platform-browser';
import { ApplicationRef, ComponentFactoryResolver, Type, DOCUMENT } from '@angular/core';
import { StoreModule } from '@ngrx/store';
// Utils
import { getLogger } from 'NewAngular/state/logger';
// Module imports
import { ConfigModule } from 'NewAngular/config/config.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { PasskeyLoginModule } from 'PasskeysApp/features/passkey-login/passkey-login.module';
import { PasswordRevealModule } from 'NewAngular/features/components/password-controls/password-reveal//password-reveal.module';
import { PasswordResetModule } from 'NewAngular/features/components/password-controls/password-reset/password-reset.module';
// Component imports
import { PasskeyLoginComponent } from 'PasskeysApp/features/passkey-login/passkey-login.component';
import { PasswordRevealComponent } from 'NewAngular/features/components/password-controls/password-reveal//password-reveal.component';
import { PasswordResetComponent } from 'NewAngular/features/components/password-controls/password-reset/password-reset.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class LoginModule {
    constructor(_document, componentFactoryResolver) {
        this._document = _document;
        this.componentFactoryResolver = componentFactoryResolver;
    }
    ngDoBootstrap(applicationRef) {
        LoginModule.bootstrapComponents.forEach((component) => {
            const { selector } = this.componentFactoryResolver.resolveComponentFactory(component);
            if (this._document.querySelector(selector)) {
                applicationRef.bootstrap(component);
            }
        });
    }
}
/*
 * DoBootstrap enables manual bootstrapping for the selected bootstrap components
 * instead of using the bootstrap array.
 * This enables a template to have different entry components without hiding them.
 */
LoginModule.bootstrapComponents = [
    PasswordRevealComponent,
    PasswordResetComponent,
    PasskeyLoginComponent,
    TopBarNavComponent,
];
LoginModule.ɵfac = function LoginModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoginModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
LoginModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LoginModule });
LoginModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        NavigationModule,
        PasswordRevealModule,
        PasswordResetModule,
        PasskeyLoginModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
